<template>
  <div class="container-fluid">
    <vs-breadcrumb :items="[
          { title: 'Seguridad', url: '/security' },
          { title: 'Gestión de accesos temporales', active: true },
      ]"></vs-breadcrumb>

    <div class="row">
      <div class="col-md-8">
        <vx-card title="Solicitudes pendientes por autorizar">
          <vs-table
              pagination
              :data="pendingRequests"
              no-data-text="No ha solicitudes pendientes por aprobar">
            <template slot="thead">
              <vs-th>Usuario</vs-th>
              <vs-th>Modúlo</vs-th>
              <vs-th>Motivo</vs-th>
              <vs-th>F. Solicitud</vs-th>
              <vs-th>F. Expiración</vs-th>
              <vs-th>Opciones</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="requestPending in data">
                <vs-td>{{requestPending.user.alias}}</vs-td>
                <vs-td>{{requestPending.backoffice_menu_item.text}}</vs-td>
                <vs-td>{{requestPending.request_purpose}}</vs-td>
                <vs-td>{{requestPending.created_at|humanizeDate}}</vs-td>
                <vs-td>{{requestPending.validity_date}}</vs-td>
                <vs-td style="width: 120px;" class="flex">
                  <vs-tooltip text="Autorizar" class="float-left">
                    <vs-button
                      class="mr-2"
                      icon="check_circle"
                      size="small"
                      @click="authorize(requestPending)"
                    ></vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Denegar" class="float-left">
                    <vs-button
                      icon="block"
                      class="ml-2"
                      color="danger"
                      size="small"
                      @click="deny(requestPending)"></vs-button>
                  </vs-tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="col-md-4">
        <vx-card title="Solicitudes vigentes">
          <vs-table
              pagination
              :data="validRequests"
              no-data-text="No ha solicitudes vigentes">
            <template slot="thead">
              <vs-th>Usuario</vs-th>
              <vs-th>Modúlo</vs-th>
              <vs-th>F. Solicitud</vs-th>
              <vs-th>Opciones</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="requestValid in data">
                <vs-td>{{requestValid.user.alias}}</vs-td>
                <vs-td>{{requestValid.backoffice_menu_item.text}}</vs-td>
                <vs-td>{{requestValid.created_at|humanizeDate}}</vs-td>
                <vs-td>
                  <vs-button
                    @click="revoke(requestValid)"
                    v-if="requestValid.status === 'valid'"
                    type="border"
                    color="danger"
                    size="small"
                  >
                    Revocar
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import {_humanizeDate} from "@/filters/momentTzConvert";
export default {
  name: "Index",
  data: () => ({
    pendingRequests: [],
    validRequests: [],
  }),
  filters: {
    humanizeDate: _humanizeDate
  },
  async mounted() {
    await this.main();
  },
  methods: {
    async main() {
      const pendingRequestResponse = await axios.get('/api/security/temporary-access');
      this.pendingRequests = pendingRequestResponse.data;

      const validRequestResponse = await axios.get('/api/security/temporary-access/valid');
      this.validRequests = validRequestResponse.data;
    },
    authorize(temporaryAccess) {
      this.confirmationDialog(async () => {
        this.$vs.loading();
        try {
          await axios.post('/api/security/temporary-access/authorize/' + temporaryAccess.id)
          await this.main()
          this.successNotif('¡Listo!', 'Has autorizado el permiso correctamente')
        } catch(e) {
          this.$vs.loading.close();
          this.errorNotif('¡Ups!', 'Hubo un problema al generar la autorización del permiso')
        } finally {
          this.$vs.loading.close();
        }
      },
          'Confimación para autorización',
          'De clic en "Aceptar" para confirmar la autorización del permiso temporal'
      )
    },
    deny(temporaryAccess) {
      this.confirmationDialog(async () => {
        this.$vs.loading();
        try {
          await axios.post('/api/security/temporary-access/deny/' + temporaryAccess.id)
          await this.main()
          this.successNotif('¡Listo!', 'Se denego el permiso correctamente')
        } catch(e) {
          this.$vs.loading.close();
          this.errorNotif('¡Ups!', 'Hubo un problema al denegar del permiso')
        } finally {
          this.$vs.loading.close();
        }
      },
      'Confimación para denegación de permiso',
      'De clic en "Aceptar" para confirmar la denegación del permiso temporal'
      )
    },
    revoke(temporaryAccess) {
      this.confirmationDialog(async () => {
        this.$vs.loading();
        try {
          await axios.post('/api/security/temporary-access/revoke/' + temporaryAccess.id)
          await this.main()
          this.successNotif('¡Listo!', 'Se revocarón el permiso correctamente')
        } catch(e) {
          this.$vs.loading.close();
          this.errorNotif('¡Ups!', 'Hubo un problema al revocar del permiso')
        } finally {
          this.$vs.loading.close();
        }
      },
      'Confimación para revocación de permiso',
      'De clic en "Aceptar" para confirmar la revocación del permiso temporal'
      )
    }
  }
}
</script>
